<template>
    <div class="qr-code-box">
        <h3 class="qr-code-box__title"
            v-if="userIsCustomer">
            {{ $t('investmentProposal.closeWith.qr.userIsCustomer.yes.title') }}
        </h3>
        <h3 class="qr-code-box__title"
            v-else>
            {{ $t('investmentProposal.closeWith.qr.userIsCustomer.no.title') }}
        </h3>

        <ol v-if="userIsCustomer">
            <li>
                {{ isMobileDevice() ? $t('investmentProposal.closeWith.qr.userIsCustomer.yes.text1-mobile') :
                    $t('investmentProposal.closeWith.qr.userIsCustomer.yes.text1-desktop') }}
            </li>
            <li>
                {{ isMobileDevice() ? $t('investmentProposal.closeWith.qr.userIsCustomer.yes.text2-mobile') :
                    $t('investmentProposal.closeWith.qr.userIsCustomer.yes.text2-desktop') }}
            </li>
        </ol>
        <ol v-else>
            <li>
                {{ isMobileDevice() ? $t('investmentProposal.closeWith.qr.userIsCustomer.no.text1-mobile') :
                    $t('investmentProposal.closeWith.qr.userIsCustomer.no.text1-desktop') }}
            </li>
            <li>
                {{ isMobileDevice() ? $t('investmentProposal.closeWith.qr.userIsCustomer.no.text2-mobile') :
                    $t('investmentProposal.closeWith.qr.userIsCustomer.no.text2-desktop') }}
            </li>
            <li>
                {{ isMobileDevice() ? $t('investmentProposal.closeWith.qr.userIsCustomer.no.text3-mobile') :
                    $t('investmentProposal.closeWith.qr.userIsCustomer.no.text3-desktop') }}
            </li>
            <li>
                {{ isMobileDevice() ? $t('investmentProposal.closeWith.qr.userIsCustomer.no.text4-mobile') :
                    $t('investmentProposal.closeWith.qr.userIsCustomer.no.text4-desktop') }}
            </li>
        </ol>

        <div v-if="!isMobileDevice()" class="row">
            <collapsible
                class="qr-code-box__help"
                :title="$t('investmentProposal.closeWith.qr.userIsCustomer.yes.notWorkingQrHelp.title')"
                :show-on-init="true"
                v-if="userIsCustomer">
                <p>
                    {{ $t('investmentProposal.closeWith.qr.userIsCustomer.yes.notWorkingQrHelp.detailText') }}
                </p>
            </collapsible>
            <div class="col-10 offset-1">
                <div class="row">
                    <div class="qr-code-box__qr-code-wrapper col-10 col-lg-2">
                        <div class="qr-code-box__qr-code">
                            <div class="d-flex"
                                 ref="qrcode" />
                        </div>
                    </div>
                    <span class="col-separator" />
                    <div class="qr-code-box__qr-steps-wrapper col-10 col-lg-8">
                        <div v-if="!userIsCustomer">
                            <div class="qr-code-box__qr-steps not-customer">
                                <div class="qr-code-box__qr-empty-step" />
                                <Icon type="qr-code-box-steps-new-user"
                                      :height="80"
                                      :width="418" />
                                <div class="qr-code-box__qr-empty-step" />
                            </div>
                        </div>
                        <div v-if="userIsCustomer">
                            <div class="qr-code-box__qr-steps">
                                <div class="qr-code-box__qr-empty-step" />
                                <Icon type="qr-code-box-step-1-existing-user"
                                      :height="88"
                                      :width="88" />
                                <div class="qr-code-box__qr-empty-step" />
                                <Icon type="qr-code-box-step-2-existing-user"
                                      :height="88"
                                      :width="88" />
                                <div class="qr-code-box__qr-empty-step" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <a v-if="isMobileDevice()" class="btn qr-code-box__finish-request-button"
           :href="qrCode"
           target="_parent">
            <div class="d-flex">
                <Icon v-if="userIsCustomer"
                      type="mobile-finish-request-existing-customer"
                      :height="37"
                      :width="28" />
                <Icon v-if="!userIsCustomer"
                      type="mobile-finish-request-new-customer"
                      :height="37"
                      :width="32" />

                <div class="qr-code-box__finish-request-button-text">
                    {{ userIsCustomer ? $t('investmentProposal.closeWith.qr.userIsCustomer.yes.mobileButtonLabel') :
                        $t('investmentProposal.closeWith.qr.userIsCustomer.no.mobileButtonLabel') }}
                </div>

            </div>
        </a>

        <div class="qr-code-box__text3">
            <p v-if="!userIsCustomer">
                {{ $t('investmentProposal.closeWith.qr.userIsCustomer.no.closing1') }} <strong>{{
                    $t('investmentProposal.closeWith.qr.userIsCustomer.no.closing2') }}</strong>
            </p>
        </div>
        <div class="row">
            <div v-if="!userIsCustomer"
                 class="col-lg-10 offset-lg-1">
                <div class="d-lg-flex">
                    <div class="new-customer__icon-text-wrapper">
                        <div class="new-customer__icon">
                            <Icon type="idDocument"
                                  :height="45"
                                  :width="45" />
                        </div>
                        <div class="new-customer__text-wrapper">
                            <div>
                                <strong>{{ $t('investmentProposal.closeWith.qr.userIsCustomer.no.id.title') }}</strong>
                            </div>
                            <div>{{ $t('investmentProposal.closeWith.qr.userIsCustomer.no.id.swiss') }}</div>
                            <div>{{ $t('investmentProposal.closeWith.qr.userIsCustomer.no.id.other') }}</div>
                        </div>
                    </div>
                    <div class="new-customer__icon-text-wrapper">
                        <div class="new-customer__icon">
                            <Icon type="swiss-geomarker"
                                  :height="55"
                                  :width="55" />
                        </div>
                        <div class="new-customer__text-wrapper">
                            <div>
                                <strong>
                                    {{ $t('investmentProposal.closeWith.qr.userIsCustomer.no.residence.title') }}
                                </strong>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import QRCode from 'qrcode';
import Collapsible from '@/components/common/Collapsible';
import isMobileDevice from '@/mixins/isMobileDevice';

export default {
    name: 'QrCodeBox',
    components: {
        Collapsible,
    },
    props: {
        userIsCustomer: {
            type: Boolean,
            required: true,
        },
        qrCode: {
            type: String,
            required: true,
        },
    },
    watch: {
        qrCode () {
            this.renderQrCode();
        },
    },
    mixins: [isMobileDevice],
    methods: {
        renderQrCode () {
            QRCode.toCanvas(this.qrCode, {
                margin: 0,
                width: 145,
            })
                .then(canvas => {
                    this.$refs.qrcode.innerHTML = '';
                    this.$refs.qrcode.appendChild(canvas);
                })
                .catch(err => {
                    // eslint-disable-next-line no-console
                    console.error(err);
                });
        },
    },
    mounted () {
        this.renderQrCode();
    },
    destroyed () {
        this.$emit('qrCodeBoxDestroyed');
    },
};
</script>

<style scoped lang="scss">
    .qr-code-box {
        background: $mb-grey-14;
        padding: 20px 15px;

        @include media-breakpoint-down(xs) {
            padding: 15px 10px;
        }

        ol {
            @include font-copy();
            padding-left: 16px;

            margin-bottom: 30px;

            @include media-breakpoint-down(xs) {
                margin-bottom: 15px;
            }
        }

        p {
            margin: 0;
        }
    }

    .qr-code-box__title {
        color: $mb-darkgreen;

        @include media-breakpoint-down(xs) {
            font-size: 16px;
            line-height: 18px;
        }
    }

    .qr-code-box__qr-code {
        display: flex;
        background: #fff;
        align-items: center;
        justify-content: center;
        height: 145px;
    }

    .qr-code-box__qr-code-wrapper {
        @media (min-width: 720px) and (max-width: 979px) {
            max-width: 28%;
        }
    }

    .qr-code-box__qr-steps-wrapper {
        @media (min-width: 720px) and (max-width: 979px) {
            max-width: 60%;
        }
    }

    .qr-code-box__qr-steps {
        display: flex;
        align-items: center;
        background: $mb-lightgreen;
        height: 145px;

        &.not-customer {
            .icon {
                padding: 0 10px 0 10px;

                ::v-deep svg {
                    height: fit-content;
                }
            }
        }
    }

    .qr-code-box__qr-empty-step {
        flex-grow: 1;
        flex-basis: 0;
    }

    .qr-code-box__finish-request-button {
        display: block;
        text-align: left;
        background: $primary;
        color: #fff;
        padding: 10px;

        &:active {
            background: $secondary;
        }

        .icon {
            margin-right: 10px;
        }
    }

    .qr-code-box__finish-request-button-text {
        display: flex;
        align-items: center;

        @include media-breakpoint-down(xs) {
            font-size: 14px;
            line-height: 18px;
        }
    }

    .qr-code-box__text3 {
        margin: 30px 0;

        @include media-breakpoint-down(xs) {
            margin: 15px 0;
        }
    }

    .qr-code-box__help {
        margin-top: 10px;
        margin-left: 22px;
        max-width: 80%;

        @media (min-width: 720px) {
            max-width: 100% !important;
            margin-left: 64px;
        }
    }

    .new-customer__icon-text-wrapper {
        display: flex;
        flex-grow: 1;
        flex-basis: 0;

        @include media-breakpoint-down(xs) {
            & ~ .new-customer__icon-text-wrapper {
                margin-top: 9px;
            }
        }
    }

    .new-customer__icon {
        display: flex;
        align-items: center;
        justify-content: center;
        background: $mb-darkgreen;
        width: 45px;
        height: 45px;
        margin: 5px 20px 0 0;
    }

    .new-customer__text-wrapper {
        @include font-copy();
        font-size: 12px;
        line-height: 20px;
    }
</style>
